export default ($element) => {
    if ($('#get-current-location').length < 1) {
        return false;
    }

    const $paolaLocationId = $('#electricity_paolaLocationId');
    const $electricityZIP = $('#electricity_plz');
    const $getCurrentLocation = $('#get-current-location');
    const $getLocation = $('#get-location');

    let geolocationData = {};

    $getCurrentLocation.on('click', function(event) {
        event.preventDefault();

        $getLocation.html(' <img class="wait-animation" src="images/rolling.svg"> Aktueller Standort wird ermittelt');

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(success);
        } else {
            return false;
        }
    });

    $electricityZIP.on('change', function () {
        if ($electricityZIP.length >= 5) {
            $getCurrentLocation.fadeOut();
        }
    });

    function success(position) {
        // Check if the user has enter zipCode
        if ($electricityZIP.val().length > 1) {
            return false;
        }

        geolocationData = {
            'latitude' : position.coords.latitude,
            'longitude' : position.coords.longitude
        };

        $.ajax({
            url: 'get-geolocation',
            type: 'POST',
            data: geolocationData,
            success: function(data) {
                if (data.success) {
                    updateForm(data);
                }
            }
        });
    }

    function updateForm(data) {
        if (data.zipCode) {
            $electricityZIP.val(data.zipCode);
        }

        if (data.allPaolaLocation) {
            let key = Object.keys(data.allPaolaLocation)[0];
            let paolaLocations = data.allPaolaLocation[key];

            if (typeof paolaLocations === 'string') {
                $paolaLocationId.append($(`<option value="null" checked="checked" selected="">${paolaLocations}</option>`));
            }

            if (typeof paolaLocations === 'object') {
                $.each(paolaLocations, function (i, item) {
                    $paolaLocationId.append($('<option>', {
                        value: i,
                        text : item
                    }));
                });
            }
        }

        $getLocation.hide();
    }
};
